//
//
//
//
//
//
//

    export default {
      name: "couponTip",
      props: {
        title:{
            type: String,
            default: ""
		}
      },
      data(){
        return{
            tipImg:require("../../../assets/images/icont12@2x.png")
        }
      },
      mounted() {
        this.$store.commit('UPDATE_HEAD',false);
        this.$store.commit('UPDATE_FOOTER',false);
        // this.$store.commit('UPDATE_PAGE_TITLE','小棉花官网');
        // document.title = '小棉花官网'
        console.log(this.title)
      },
    }



// WEBPACK FOOTER //
// ./src/components/cardCoupons/component/couponTip.vue